import { IAddFavoriteResponse, IAddFavoriteResponse200 } from '../../../../repositories/favorites/v1/add-favorite';

export const mapAddFavoriteResponse = (response: IAddFavoriteResponse): IAddFavoriteResponse200 => {
  return {
    statusCode: 200,
    headers: [],
    response,
  };
};
